module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00706.16670af7.jpg";